import useMemoizedFn from "ahooks/es/useMemoizedFn";
import { atom, useAtom } from "jotai";
import { trackOpenConferenceDialog } from "../../../../tracking";

type ConferenceFormState = {
  isOpen: boolean;
};

export type UseConferenceFormResult = ConferenceFormState & {
  isOpen: boolean;
  openDialog(): void;
  closeDialog(): void;
};

const formStateAtom = atom<ConferenceFormState>({
  isOpen: false,
});

export function useConferenceForm(): UseConferenceFormResult {
  const [formState, setFormState] = useAtom(formStateAtom);

  const openDialog = useMemoizedFn(() => {
    trackOpenConferenceDialog();
    setFormState({
      isOpen: true,
    });
  });

  const closeDialog = useMemoizedFn(() => {
    setFormState({
      isOpen: false,
    });
  });

  return {
    ...formState,
    openDialog,
    closeDialog,
  };
}
